import { Box } from '@eatclubapp/ec-component-library';
import moment from 'moment-timezone';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { eventPropTypes } from '../../../../../data/models/Event';
import { restaurantPropTypes } from '../../../../../data/models/Restaurant';
import { onlyUnique } from '../../../../../utils/helpers';
import { Date } from './Date';
import { Slider } from './Slider';

const DateScroll = ({ restaurant, event }) => {
  const today = moment().startOf('day');

  const sessions = restaurant.data.areas.flatMap((area) => area.sessions);

  const openDays = sessions.map((session) => session.day).filter(onlyUnique);
  const openDates = sessions.map((session) => session.date).filter(onlyUnique);
  const eventDates = event?.data?.eventDates;

  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const measureWidth = () => {
      if (ref.current) {
        setWidth(ref.current.offsetWidth);
      }
    };

    // Measure after render and when the window is resized
    measureWidth();
    window.addEventListener('resize', measureWidth);

    return () => {
      window.removeEventListener('resize', measureWidth);
    };
  }, [ref]);

  if (event?.data) {
    // Calculate item width based on number of items, default to 100% if no items
    const maxItems = Math.min(6, Math.floor(width / 110));
    const itemWidth =
      eventDates.length <= maxItems
        ? `calc((100% - 8px * ${eventDates.length - 1}) / ${eventDates.length})`
        : 'unset';
    const showDateInOneLine = eventDates.length <= maxItems;

    return (
      <Box ref={ref}>
        <Slider
          style={{
            width: '100%',
            ...(showDateInOneLine && { minHeight: '60px', height: 'unset' }),
          }}
          items={(eventDates ?? []).map((day) => {
            const date = moment(day);
            const isToday = date.isSame(moment(), 'day');

            return (
              <Box
                style={{
                  width: itemWidth,
                  flexShrink: 0,
                }}
              >
                <Date
                  key={`date-${date.unix()}`}
                  today={date}
                  disabled={false}
                  isToday={isToday}
                  style={{
                    width: '100%',
                    button: {
                      width: '100%',
                    },
                  }}
                  showDateInOneLine={showDateInOneLine}
                  dateFormat='MMM YY'
                />
              </Box>
            );
          })}
        />
      </Box>
    );
  }

  return (
    <Slider
      items={Array.from({ length: restaurant.data.daysInAdvance + 1 }, (_, i) => i).map((day) => {
        const date = moment(today).add(day, 'days');

        const closed = restaurant.data.closures?.some((closure) => {
          return date.isBetween(moment(closure.startDate), moment(closure.endDate), 'day', '[]');
        });

        const disabled =
          closed ||
          (!openDays.includes(date.format('ddd').toLowerCase()) &&
            !openDates.includes(date.format('YYYY-MM-DD')));

        return (
          <Date key={`date-${date.unix()}`} today={date} disabled={disabled} isToday={day === 0} />
        );
      })}
    />
  );
};

DateScroll.propTypes = {
  restaurant: restaurantPropTypes.isRequired,
  event: eventPropTypes.isRequired,
};

const mapStateToProps = (state) => ({
  restaurant: state.restaurant,
  event: state.event,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DateScroll);
